module.exports = __webpack_public_path__ + "img/SINGLE_ROLE_A1014.3d6c46f0.png";